import React from 'react';
import { Query } from 'react-apollo';
import { InjectedRouter } from 'react-router';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import CoachingHelpHomeView from 'coaching/components/CoachingHelpFormView/CoachingHelpHomeView';
import GET_COACHING_HELP_FORM from 'coaching/queries/GetCoachingHelpForm.gql';
import { GetCoachingHelpForm } from 'coaching/queries/__generated__/GetCoachingHelpForm';

type Props = {
  router: InjectedRouter;
};

export default function CoachingHelpContainer(props: Props) {
  return (
    <Query<GetCoachingHelpForm> query={GET_COACHING_HELP_FORM}>
      {({ data, loading }) => {
        if (loading) {
          return <CenteredLoadingIndicator />;
        }

        const me = data?.me;

        return <CoachingHelpHomeView {...props} me={me} />;
      }}
    </Query>
  );
}
